import type { FunctionComponent, ReactElement } from 'react';
import {
  boolean,
  enums,
  literal,
  object,
  optional,
  string,
  union,
  func,
} from 'superstruct';
import type { Struct } from 'superstruct';

export const uiConfigSchema = object({
  theme: object(),
  themeOptions: optional(object()),
  components: optional(
    object({
      pageHeader: optional(
        object({
          shape: optional(enums(['swoop', 'line'])),
          backgroundColor: optional(string()),
        }),
      ),
      loading: optional(
        object({
          element: object() as unknown as Struct<ReactElement>,
          text: optional(union([literal(false), string()])),
        }),
      ),
      toastMessage: optional(
        object({
          component: func() as unknown as Struct<FunctionComponent<any>>,
        }),
      ),
    }),
  ),
  groupLogo: optional(
    object({
      element: optional(object() as unknown as Struct<ReactElement>),
    }),
  ),
  features: optional(
    object({
      pointsEnabled: optional(boolean()),
    }),
  ),
});
